/**
 * The Waystone mark: two irregular contour lines around a single waypoint.
 *
 * The mark is deliberately transparent so it works on the dark top bar and on
 * the light sign-in card. The outer dark-green casing disappears into the top
 * bar while the cream contour remains visible.
 */
export function Logo({ size = 24 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="-4 -4 64 64"
      role="img"
      aria-label="Waystone"
      focusable="false"
      className="logo"
    >
      <path
        d="M28 2C44 2 54 14 54 28 54 43 43 54 28 54 13 54 2 43 2 28 2 14 13 2 28 2Z"
        fill="none"
        stroke="#1b5e20"
        strokeWidth="7"
      />
      <path
        d="M28 2C44 2 54 14 54 28 54 43 43 54 28 54 13 54 2 43 2 28 2 14 13 2 28 2Z"
        fill="none"
        stroke="#f4f0df"
        strokeWidth="3.5"
      />
      <path
        d="M28 13C37 13 43 20 43 28 43 37 36 43 28 43 19 43 13 36 13 28 13 20 20 13 28 13Z"
        fill="none"
        stroke="#1b5e20"
        strokeWidth="6"
      />
      <path
        d="M28 13C37 13 43 20 43 28 43 37 36 43 28 43 19 43 13 36 13 28 13 20 20 13 28 13Z"
        fill="none"
        stroke="#f4f0df"
        strokeWidth="3"
      />
      <circle cx="28" cy="28" r="4.5" fill="#f2b84b" stroke="#1b5e20" strokeWidth="2" />
    </svg>
  );
}
